import { useMemo, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import SegmentedControl from '../../shared_components/Library/SegmentedControl'
import routes from '../../router/routes'
import { isTgeSoon, useStakingContext } from '../../contexts/StakingContext'

const ToggleStaking = () => {
  const vaultsRef = useRef(null)
  const tokensRef = useRef(null)

  const { pathname } = useLocation()
  const target = pathname.includes('/staking/vaults')
    ? 'vaults'
    : pathname.includes('/staking/tokens')
    ? 'tokens'
    : null

  const { userVaultsState } = useStakingContext()
  const hasUnstakedVaults =
    userVaultsState?.vaultsStaked <
    userVaultsState?.vaultsHeld - userVaultsState?.vaultsClaimed

  const segments = useMemo(() => {
    if (!target) return []
    return [
      {
        link: routes.staking.vaults,
        value: 'vaults',
        label: 'Vaults',
        tooltip: isTgeSoon
          ? undefined
          : hasUnstakedVaults
          ? {
              label: 'You have unstaked vaults',
              id: 'tooltip-vault-segmented',
              defaultIsOpen: true,
            }
          : undefined,
        ref: vaultsRef,
      },
      {
        link: routes.staking.tokens,
        value: 'tokens',
        label: 'Tokens',
        ref: tokensRef,
      },
    ]
  }, [target, hasUnstakedVaults])

  if (!target) return null

  return (
    <SegmentedControl
      name="staking-target"
      segments={segments}
      defaultIndex={target === 'vaults' ? 0 : 1}
    />
  )
}

export default ToggleStaking
